import WorkModal from './WorkModal';
import withBrowserInfo from '../../containers/redux/withBrowserInfo';

const WorkModalWithBrowserInfo = withBrowserInfo(WorkModal);

WorkModalWithBrowserInfo.displayName = WorkModal.displayName;

export default WorkModalWithBrowserInfo;
